(function () {
  var NEEDS_BY_PANEL = new WeakMap();

  function parseNeeds(root) {
    var configEl = root.parentElement && root.parentElement.querySelector('[data-wh-quiz-config]');
    if (!configEl && root.nextElementSibling && root.nextElementSibling.matches('[data-wh-quiz-config]')) {
      configEl = root.nextElementSibling;
    }
    if (!configEl) {
      var sibling = root.querySelector('[data-wh-quiz-config]');
      configEl = sibling || root.parentElement.querySelector('script[data-wh-quiz-config]');
    }
    if (!configEl) return { dog: [], cat: [] };
    try {
      return JSON.parse(configEl.textContent);
    } catch (e) {
      return { dog: [], cat: [] };
    }
  }

  function initQuizRoot(root) {
    var interactive = root.querySelector('[data-wh-quiz-interactive]');
    if (!interactive || interactive.dataset.whQuizBound === 'true') return;
    interactive.dataset.whQuizBound = 'true';

    var needs = parseNeeds(root);
    NEEDS_BY_PANEL.set(root, needs);

    var step1 = root.querySelector('[data-wh-quiz-step="1"]');
    var step2 = root.querySelector('[data-wh-quiz-step="2"]');
    var needsList = root.querySelector('[data-wh-quiz-needs]');
    var backBtn = root.querySelector('[data-wh-quiz-back]');
    var progressDots = root.querySelectorAll('[data-wh-quiz-progress]');

    function setProgress(step) {
      progressDots.forEach(function (dot) {
        dot.classList.toggle('is-active', dot.getAttribute('data-wh-quiz-progress') === String(step));
      });
    }

    function showStep(step) {
      step1.hidden = step !== 1;
      step2.hidden = step !== 2;
      step1.classList.toggle('is-active', step === 1);
      step2.classList.toggle('is-active', step === 2);
      setProgress(step);
      var focusTarget = step === 1 ? step1.querySelector('button') : needsList.querySelector('button');
      if (focusTarget) focusTarget.focus();
    }

    function renderNeeds(key) {
      needsList.innerHTML = '';
      (needs[key] || []).forEach(function (item) {
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wh-btn-secondary wh-quiz__option';
        btn.textContent = item.label;
        btn.addEventListener('click', function () {
          window.location.assign(item.url);
        });
        li.appendChild(btn);
        needsList.appendChild(li);
      });
    }

    interactive.hidden = false;

    root.querySelectorAll('[data-wh-quiz-species]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        renderNeeds(btn.getAttribute('data-wh-quiz-species'));
        showStep(2);
      });
    });

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        showStep(1);
      });
    }

    showStep(1);
  }

  function getFocusable(container) {
    return Array.prototype.slice
      .call(
        container.querySelectorAll(
          'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
        )
      )
      .filter(function (el) {
        return !el.hidden && el.offsetParent !== null;
      });
  }

  var modal = document.getElementById('wh-quiz-modal');
  var lastOpener = null;
  var scrollLockY = 0;

  function lockScroll() {
    scrollLockY = window.scrollY || document.documentElement.scrollTop;
    document.documentElement.classList.add('wh-quiz-modal-open');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollLockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.classList.add('wh-quiz-modal-open');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('wh-quiz-modal-open');
    document.body.classList.remove('wh-quiz-modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollLockY);
  }

  function trapFocusInModal(event) {
    if (!modal || !modal.open) return;
    var dialog = modal.querySelector('.wh-quiz-modal__dialog');
    if (!dialog) return;
    var focusable = getFocusable(dialog);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.key === 'Tab') {
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  function openModal(opener) {
    if (!modal || typeof modal.showModal !== 'function') {
      window.location.href = opener.getAttribute('href') || '/pages/quiz';
      return;
    }
    lastOpener = opener;
    var panel = modal.querySelector('[data-wh-quiz-root]');
    if (panel) {
      var interactive = panel.querySelector('[data-wh-quiz-interactive]');
      if (interactive && interactive.dataset.whQuizBound !== 'true') {
        initQuizRoot(panel);
      } else if (panel) {
        var step1 = panel.querySelector('[data-wh-quiz-step="1"]');
        var step2 = panel.querySelector('[data-wh-quiz-step="2"]');
        if (step1 && step2) {
          step1.hidden = false;
          step2.hidden = true;
          step1.classList.add('is-active');
          step2.classList.remove('is-active');
          panel.querySelectorAll('[data-wh-quiz-progress]').forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === 0);
          });
        }
      }
    }
    lockScroll();
    modal.showModal();
    var firstBtn = modal.querySelector('[data-wh-quiz-species]');
    if (firstBtn) firstBtn.focus();
    document.addEventListener('keydown', trapFocusInModal);
  }

  function closeModal() {
    if (!modal || !modal.open) return;
    modal.close();
    unlockScroll();
    document.removeEventListener('keydown', trapFocusInModal);
    if (lastOpener) lastOpener.focus();
    lastOpener = null;
  }

  function bindModal() {
    if (!modal) return;
    modal.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeModal();
    });
    modal.querySelectorAll('[data-wh-quiz-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
  }

  function bindOpeners() {
    document.querySelectorAll('[data-wh-quiz-open]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        openModal(el);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-wh-quiz-root]').forEach(initQuizRoot);
    bindModal();
    bindOpeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
